export default "__VITE_ASSET__DYnCkQjw__"